module.exports = __webpack_public_path__ + "img/chrome.6fd7372b.svg";